import uploadDone from '../actions/uploadDone.js'

export default [uploadDone]



// WEBPACK FOOTER //
// ./src/modules/user/chains/uploadDone.js